import React, { useState, useEffect } from 'react'
import { Route, Redirect } from 'react-router-dom'

import {useSelector} from 'react-redux'
import {ServerConfig} from 'config'
import axios from 'axios'


// nodejs library to set properties for components
import PropTypes from 'prop-types'

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Grid, Hidden, Container } from '@material-ui/core'
import { ListGroup, ListGroupItem } from 'reactstrap';
import { AppBar, Tabs, Tab } from '@material-ui/core';
import Box from "@material-ui/core/Box";

// components
import _, { get } from 'lodash'
import { hasPermission } from 'utils/hasPermission';

import Page from 'components/Page/Page'

import UpcomingPickups from './UpcomingPickups.js'
import CustomPickupRequests from './CustomPickupRequests.js'
import AvailablePickupDays from './AvailablePickupDays.js'

const useStyles = makeStyles((theme) => ({}))

const PickupPage = (props) => {
  const auth = useSelector(state => state.auth)
  const classes = useStyles()

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  if(!auth.access_token){
    return <Redirect to="/login" />
  }

  const isAdmin = hasPermission(auth.permissions, ['Admin', 'admin']);
  const isDriver = hasPermission(auth.permissions, ['Driver', 'user']);
  
  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div {...other}>
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    );
  }

  return (
    <Page title="Shop">
        <Container maxWidth={false}>

        <AppBar position="static">
          <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
            <Tab label="Next Pickups" />
            {isAdmin &&
		    <Tab label="Custom Pickup Requests" />
	    }
            {isAdmin &&
		    <Tab label="Manage Pickup Days" />
	    }
          </Tabs>
        </AppBar>
        
          {(isAdmin || isDriver) &&
        <TabPanel value={value} index={0}>
                    <UpcomingPickups />
        </TabPanel>
                }

          {isAdmin &&
        <TabPanel value={value} index={1}>
                    <CustomPickupRequests />
        </TabPanel>
                }

          {isAdmin &&
        <TabPanel value={value} index={2}>
                    <AvailablePickupDays />
        </TabPanel>
                }
        </Container>
    </Page>
  )
}

export default PickupPage

PickupPage.propTypes = {
  children: PropTypes.node
}
